/**
 * LNB 포함 서브 페이지 Layout
 */
import { Outlet } from "react-router";
import Lnb from "@core/layouts/lnb/Lnb";

export default function SubPageLayout() {
  return (
    <div className="padding-side mx-auto max-w-[1260px] lg:flex">
      {/* lnb들어올 영역 - PC 뷰에서만 표시 */}
      <Lnb />
      {/* 컨텐츠 영역 */}
      <section className="w-full max-lg:pt-[20px]">
        <Outlet />
      </section>
    </div>
  );
}
